import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faClone } from "@fortawesome/pro-regular-svg-icons";
import { Tooltip } from "~/components/Tooltip";
import { useCopyToClipboard } from "~/components/CopyToClipboard";

interface Props {
    slug: string;
}

export function CopySlugBadge({ slug }: Props) {
    const [copied, setCopied] = useState(false);
    const [hidden, setHidden] = useState(false);
    const [copyToClipboard] = useCopyToClipboard(() => setCopied(true));

    useEffect(() => {
        if (copied) {
            setHidden(true);

            setTimeout(() => setCopied(false), 1000);
            setTimeout(() => setHidden(false), 50);
        }
    }, [copied]);

    const message = copied ? "Copied!" : "Copy to clipboard";

    return (
        <Tooltip
            placement="top"
            tooltipContent={
                hidden ? null : (
                    <div className="w-max px-2 py-0.5 text-center">
                        <p className="whitespace-nowrap text-xs font-light">
                            {message}
                        </p>
                    </div>
                )
            }
        >
            {({ setTriggerRef }) => (
                <button
                    type="button"
                    ref={setTriggerRef}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        copyToClipboard(slug);
                    }}
                    className="inline-flex items-center gap-2 rounded-full border bg-card px-3 py-1.5 select-none"
                >
                    <span className="text-sm text-muted-foreground">Slug</span>
                    <span className="text-xs font-mono font-medium text-foreground leading-none gap-1.5 inline-flex items-center">
                        {slug}
                        <FontAwesomeIcon
                            icon={copied ? faCheck : faClone}
                            className={
                                copied
                                    ? "h-3 text-emerald-700"
                                    : "h-3 text-muted-foreground"
                            }
                        />
                    </span>
                </button>
            )}
        </Tooltip>
    );
}
